module.exports = __webpack_public_path__ + "img/ruble-sign.f993651b.svg";